import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  fieldList: {
    display: 'grid',
    gap: spacing(24),
  },
  deleteButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '-1px',
    // paddingTop: '14px',
  },
  deleteButton: {
    padding: spacing(8),
    minWidth: '36px',
  },
  fullWidth: {
    width: '100%',
  },
  label: {
    marginTop: '10px',
    fontSize: Theme.Typography.FontSize.Tiny,
    color: Theme.Colors.Grayscale.ThirtyTwo,
  },
  selectWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '200px',
    marginTop: '0px',
    padding: '0px 8px 0 0px',
    gap: '7px',
    flex: props => {
      if (props?.poolAvailable) {
        if (!props?.multipleTradesman) return 1
        return 'unset'
      }
      return props?.multipleTradesman ? 'unset' : 1
    },
    paddingRight: props => {
      if (props?.poolAvailable) {
        return props?.multipleTradesman ? '10px' : '8px'
      }
      return props?.multipleTradesman ? '8px' : 0
    },
    marginBottom: spacing(16),
  },
  selectWrapperWithPool: {
    width: '85%',
    padding: '0px 28px 0 50px',
  },
  roundLabel: {
    fontSize: `${Theme.Typography.FontSize.Tiny} !important`,
    color: `${Theme.Colors.Grayscale.ThirtyTwo} !important`,
  },
  select: {
    width: '100%',
  },
  selectLabel: {
    fontWeight: '400',
    width: '100%',
  },
  showReferaSuggestions: {
    margin: '0 0 16px',
  },
  runPool: {
    alignSelf: 'center',
  },
  customSelectLabel: {
    color: '#B4B4B4',
    fontSize: '12px',
    marginTop: '14px !important',
    marginBottom: '-8px !important',
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  customSelectContainer: {
    height: '28px',
    width: '80px',
  },
  hidden: {
    display: 'none',
  },
  customSelect: {
    width: props => {
      if (props?.poolAvailable) {
        return props?.multipleTradesman ? '36px' : '46px'
      }

      return props?.multipleTradesman ? '36px' : '46px'
    },
  },
  addProviderContainer: {
    marginTop: spacing(16),
  },
  tooltip: {
    '& .MuiTooltip-tooltip': {
      backgroundColor: palette.primary.main,
      color: palette.gray[4],
    },
    '& .MuiTooltip-arrow': {
      color: palette.primary.main,
    },
  },
  tooltipBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  center: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  li: {
    width: '100%',
  },
  svgIcon: {
    width: '40px',
    height: '40px',
  },
  tableContainer: {
    width: '100%',
    overflowX: 'auto',
    borderRadius: 12,
    border: '#d3d3d3 solid 1px',
    marginTop: spacing(16),
    paddingBottom: spacing(16),
  },
  tableHeader: {
    borderBottom: '#d3d3d3 solid 1px',
    paddingLeft: spacing(20),
    paddingRight: spacing(20),
    paddingTop: spacing(20),
    paddingBottom: spacing(12),
    marginBottom: spacing(12),
  },
  tableRow: {
    paddingLeft: spacing(16),
    paddingRight: spacing(16),
  },
  modalRoot: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '1140px',
    },
  },
  title: {
    color: Theme.Colors.Primary.Base,
    fontWeight: 500,
    fontSize: Theme.Typography.FontSize.Small,
  },
  modalContent: {
    borderTop: `1px solid #d3d3d3`,
    marginTop: spacing(20),
    paddingLeft: spacing(20),
    paddingRight: spacing(20),
  },
  description: {
    marginTop: spacing(-8),
    marginLeft: spacing(20),
    marginRight: spacing(20),
  },
  required: {
    marginLeft: '5px',
    color: 'red',
    fontSize: '16px',
  },

  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: spacing(14),
    marginRight: spacing(14),
    marginBottom: spacing(14),
  },
  sortIconButton: {
    transition: 'background 0.2s',
    '&:hover': {
      background: '#F3F4F6', // cinza claro
    },
    borderRadius: '50%',
    padding: 4,
  },
  arrowIconUnselected: {
    opacity: 0,
    '&:hover': {
      opacity: 1,
    },
  },
  rateIcon: {
    // marginRight: '4px',
  },
  fieldGrid: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },

  button: {
    padding: spacing(8, 16),
    margin: '0 !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    minWidth: spacing(120),
    height: 'fit-content',

    backgroundColor: 'transparent',
    fontSize: spacing(14),
    borderRadius: '75px',
    background: 'transparent',

    color: palette.primary.main,
    border: `1px solid ${palette.primary.main}`,

    '&:not(:disabled):hover': {
      background: palette.primary.main,
      color: palette.gray[4],
    },

    '&:disabled': {
      border: `1px solid ${palette.primary.main}`,
    },
  },
  supportIcon: {
    marginRight: spacing(8),
  },
  link: {
    color: palette.primary.main,
    fontSize: spacing(14),
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  tooltipTrigger: {
    display: 'flex',
    alignItems: 'center',
    color: palette.primary.main,
    fontSize: spacing(7),
  },
  autocompleteContainerClasses: {
    width: '565px',
    paddingRight: '10px',
    paddingTop: '1px',
  },
  autocompleteComponentClasses: {
    '& .MuiFormLabel-root': {
      // paddingRight: '0px !important',
      fontSize: '18.75px !important',
      height: '24px !important',
      top: '-1px !important',
    },
  },

  footer: {
    margin: '40px 0 0 20px',
  },
  loadbutton: {
    flex: 1,
    padding: '4px 2px',
    borderRadius: '5px',
    backgroundColor: palette.primary.main,
    color: palette.common.white,

    '& span': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
    },
  },
  buttonIcon: {
    fontSize: '16px',
    fill: palette.common.white,
    marginRight: '4px',
  },
  newChip: {
    backgroundColor: palette.yellow.main,
    color: '#000',
    marginLeft: '8px',
    borderColor: palette.yellow.main,
    fontSize: spacing(8),
    lineHeight: spacing(12),
    height: '15px',
  },
}))
